import { watch } from 'vue'

import { type StepProgress, freshlyDoneSteps } from '@/lib/setup/setup-motion'

/** Calls back once for each step that turns done while on screen; a step read back as done from saved data never does. */
export function useStepCompletion(
  steps: () => readonly StepProgress[],
  onDone: (index: number) => void,
): void {
  watch(
    () => steps().map((entry) => entry.state),
    (_states, before) => {
      for (const index of freshlyDoneSteps(before, steps())) onDone(index)
    },
    { flush: 'post' },
  )
}
